import routes from '@/constants/routes';

export default [
  {
    name: 'footer.navigation.0',
    to: routes.ABOUT,
  },
  {
    name: 'footer.navigation.1',
    to: routes.TERMS,
  },
  // {
  //   name: 'footer.navigation.2',
  //   to: routes.SECURITY,
  // },
  {
    name: 'footer.navigation.3',
    to: routes.PRIVACY,
  },
];
